angular.module("app").filter('convertDateToUserTimezone', function() { return function(date, format, outputFormat) {
    format = format || "YYYY-MM-DD HH:mm:ss";
    return date? moment.tz(moment.tz(date,  format, "Asia/Yerevan"), moment.tz.guess()).format(outputFormat? outputFormat:format): '';

}});
